module.exports = __webpack_public_path__ + "static/media/NF.e3deb27e.jpg";